import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useApiGet = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getData = async (url, params = {}) => {
    const token = Cookies.get("Snapta_Admin_Token");
    try {
      setLoading(true);
      setError(null);
      const headers = {
        ...(token && { Authorization: `Bearer ${token}` }),
      };
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.get(`${apiUrl}${url}`, { headers, params });
      setData(response.data);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };
  return { loading, error, data, getData };
};
export default useApiGet;